const stateSubscription = {
    nameState: 'State global subscription',
    pricing: []
}

export default stateSubscription;